module.exports = __webpack_public_path__ + "static/media/help.cca9d174.png";